import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

export type PatientData = {
  [key: string]: any // to allow flexibility for additional fields
}

export type PatientState = {
  data: PatientData | null
  lastUpdated: string | null
  isLoading: boolean
  selectVisitId: string | null
}

const initialState: PatientState = {
  data: null,
  lastUpdated: null,
  isLoading: false,
  selectVisitId: null,
}

const OpdPatientSlice = createSlice({
  name: 'Patient',
  initialState,
  reducers: {
    setOpdPatientData: (state, action: PayloadAction<PatientData>) => {
      state.data = action.payload
      state.lastUpdated = new Date().toISOString()
    },
    updatePatientData: (state, action: PayloadAction<Partial<PatientData>>) => {
      state.data = { ...state.data, ...action.payload }
      state.lastUpdated = new Date().toISOString()
    },
    clearPatientData: (state) => {
      state.data = null
      state.lastUpdated = new Date().toISOString()
    },
    setPatientLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setSelectedVisitId: (state, action: PayloadAction<string | null>) => {
      state.selectVisitId = action.payload
    },
  },
})

export const {
  setOpdPatientData,
  updatePatientData,
  clearPatientData,
  setPatientLoading,
  setSelectedVisitId,
} = OpdPatientSlice.actions

// Selectors
export const selectPatientData = (state: RootState) =>
  state?.SelectedOpdPatient?.data
export const selectPatientIsLoading = (state: RootState) =>
  state?.SelectedOpdPatient?.isLoading
export const selectPatientLastUpdated = (state: RootState) =>
  state?.SelectedOpdPatient?.lastUpdated
export const selectedVisitId = (state: RootState) =>
  state?.SelectedOpdPatient?.selectVisitId
export default OpdPatientSlice.reducer
